import { uniqid, clone, sample } from '@/js/utils'
const attributes = [
	{ element: 'fire', type: 'attack', status: '' },
	{ element: 'fire', type: 'defence', status: '' },
	{ element: 'ice', type: 'attack', status: '' },
	{ element: 'ice', type: 'defence', status: '' },
	{ element: 'electric', type: 'attack', status: '' },
	{ element: 'electric', type: 'defence', status: '' }
]

export const generate_card = (data)  => {
	let card = { id: uniqid(), attributes: [] }

	// let levels = [ 2 ]
	// if (data.level >= 2) levels.push(3)
	// if (data.level >= 3) levels.push(4)
	// if (data.level >= 4) levels.push(5)
	// if (data.level >= 5) levels.push(6)
	// if (data.level >= 6) levels.push(7)
	// if (data.level >= 7) levels.push(8)
	// let nb_attributes = sample(levels)
	let nb_attributes = data.level + 1

	for (var i = 0; i < nb_attributes; i++) {
		let attribute = { id: i, ...sample(attributes) }
		card.attributes.push(attribute)
	}
	
	return card
}

// 1 4 7 10 13 16